// Endpoints do BFF público (`bff/`). Fonte única.
//
// O site é SÓ LEITURA. Criar e editar tutorial acontece no CRM, sobre a base
// de conhecimento — o tutorial aqui é a PROJEÇÃO daquele artigo, não uma
// segunda cópia editável. Por isso não existe create/update/delete/publish
// nesta lista, nem auth/users: o BFF não expõe caminho de escrita e a
// api-lukos, que expõe, é privada.
//
// Passos também sumiram: vêm dentro do payload do tutorial (são o checklist do
// artigo), então não há mais `/tutorials/:id/steps`.

export const endpoints = {
  tutorials: {
    list: '/api/tutoriais',
    get: (slug: string) => `/api/tutoriais/${encodeURIComponent(slug)}`,
  },
  categories: {
    list: '/api/categorias',
  },
} as const;
